// The backend's day names, shared by StaffAvailability.weekSchedule keys, the
// staff settings form and a location's opening days. Monday-first, matching ISO
// weeks.
export type DayKey =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export const DAY_ORDER: readonly DayKey[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
] as const;

// Translation keys for each day's full name, in the user's language.
export const DAY_LABEL_KEYS: Record<DayKey, string> = {
  MONDAY: 'config-day-monday',
  TUESDAY: 'config-day-tuesday',
  WEDNESDAY: 'config-day-wednesday',
  THURSDAY: 'config-day-thursday',
  FRIDAY: 'config-day-friday',
  SATURDAY: 'config-day-saturday',
  SUNDAY: 'config-day-sunday'
};
